import { useSelector } from 'react-redux';
import { createSearchParams, useNavigate } from 'react-router-dom';
import Button from '../../../../components/Button';
import StickyPanel from '../../../../components/StickyPanel';
import AppConfig from '../../../../config';
import { t } from '../../../../lang';
import { createRootModal } from '../../RootModal';
import './LearnAboutAmlRisk.scss';

const LearnAboutAmlRisk = createRootModal(() => {
	const { routes } = AppConfig;
	const navigate = useNavigate();

	const { address } = useSelector(
		state => state.app.modals.find(modal => modal.tag === 'LearnAboutAmlRisk')?.outsideParams || {}
	);

	const amlCheck = () => {
		navigate({
			pathname: routes.amlCheck,
			search: createSearchParams({ address: address }).toString(),
		});
	};

	return (
		<div className='LearnAboutAmlRisk'>
			<StickyPanel
				controls={
					<Button
						iconBefore='AML_SCAN'
						onClick={amlCheck}
						styleType='green-dark'
						className='AddressAmlDetails__recheck'
					>
						{t('AML check')}
					</Button>
				}
			>
				<div className='LearnAboutAmlRisk_content'>
					<div className='LearnAboutAmlRisk_content_text'>
						<p className='LearnAboutAmlRisk_content_regular'>
							{t('This address has not been checked for AML risks yet.')}
						</p>
					</div>

					<div className='LearnAboutAmlRisk_content_text'>
						<p className='LearnAboutAmlRisk_content_text_bold'>{t('What does this mean?')}</p>
						<p>
							{t(
								'There is not enough data to assess the risk level of this address at the moment.\nAn unchecked status does not indicate low or high risk — it means the risk has not been evaluated.'
							)}
						</p>
						{/* <p className='LearnAboutAmlRisk_content_text_indent'>
							{'Funds associated with unchecked addresses may carry potential compliance risks.'}
						</p> */}
					</div>

					<div className='LearnAboutAmlRisk_content_text'>
						<p className='LearnAboutAmlRisk_content_text_bold'>{t('What should you do?')}</p>
						<p>
							{t(
								'Run an AML check to check the address, calculate its risk score, and view detailed information about the source and use of funds.'
							)}
						</p>
					</div>
				</div>
			</StickyPanel>
		</div>
	);
});

export default LearnAboutAmlRisk;
